import React, { useState } from 'react';
import {
  Box,
  Typography,
  CircularProgress,
  Button,
} from '@mui/material';
import { Link, useHistory } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import TaskAlt from '@mui/icons-material/TaskAlt';
import ConfirmationModal from '../Components/confirmationModal';
import { useTranslation } from "react-i18next";


const NavigationButtons = ({
  backUrl,
  nextUrl,
  onSave,
  isLoading,
  showBack,
  showSave,
  showNext = true,
  customNextText,
  loadingText = "Saving...",
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleNextClick = async () => {
    const result = await onSave('next');
    if ((result === undefined || result === true) && !isLoading) {
      history.push(nextUrl);
    }
  };

  const handleSaveClick = () => {
    setIsModalOpen(true); // Show confirmation modal
  };

  const handleCloseModal = () => {
    setIsModalOpen(false); // Close modal
  };

  const handleConfirmSave = async () => {
    setIsModalOpen(false); // Close modal after confirmation
    await onSave(); // Call the onSave function
  };

  return (
    <>
      {/* Confirmation Modal */}
      <ConfirmationModal
        isOpen={isModalOpen}
        handleClose={handleCloseModal}
        title={t("Save Progress")}
        description={t(`Please confirm that the information you’ve entered so far is correct. You can save your progress and return return later to complete the form.`)}
        onConfirm={handleConfirmSave} // Pass the confirm handler to the modal
      />

      <Box sx={{ marginTop: "32px", textAlign: "center", display: 'flex', justifyContent: 'center', gap: 2 }}>
        {/* Back Button */}
        {showBack && (
          <Button
            component={Link}
            to={backUrl}
            variant="outlined"
            sx={{
              borderRadius: "8px",
              height: "48px",
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <ArrowBackIcon sx={{ color: "#000", marginRight: "5px" }} />
            <Typography sx={{ color: "#000", fontWeight: 600, fontSize: "16px" }}>
              {t("Back")}
            </Typography>
          </Button>
        )}

        {/* Save Button */}
        {showSave && (
          <Button
            onClick={handleSaveClick} // Show confirmation modal on click
            disabled={isLoading}
            variant="outlined"
            sx={{
              borderRadius: "8px",
              height: "48px",
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              whiteSpace: 'nowrap',
            }}
          >
            {isLoading ? (
              <>
                <CircularProgress size={24} sx={{ color: "#000", marginRight: "5px" }} />
                <Typography sx={{ color: "#000", fontWeight: 600, fontSize: "16px" }}>
                  {loadingText}
                </Typography>
              </>
            ) : (
              <>
                <TaskAlt sx={{ color: "#000", marginRight: "5px" }} />
                <Typography sx={{ color: "#000", fontWeight: 600, fontSize: "16px" }}>
                  {t("Save Progress")}
                </Typography>
              </>
            )}
          </Button>
        )}

        {showNext &&
          <Button
            onClick={handleNextClick} // Call handleNextClick instead of Link
            variant="contained"
            sx={{
              background: "#2F37B5",
              borderRadius: "8px",
              height: "48px",
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            disabled={isLoading} // Disable while loading
          >
            <Typography sx={{ color: "white", fontWeight: 600, fontSize: "16px", marginRight: "5px" }}>
              {customNextText || t('Next')}
            </Typography>
            <ArrowForwardIcon sx={{ color: "white" }} />
          </Button>
        }
      </Box>
    </>
  );
};

export default NavigationButtons;